import { render, staticRenderFns } from "./VarietyForm.vue?vue&type=template&id=ce055536&scoped=true&"
import script from "./VarietyForm.vue?vue&type=script&lang=js&"
export * from "./VarietyForm.vue?vue&type=script&lang=js&"
import style0 from "./VarietyForm.vue?vue&type=style&index=0&id=ce055536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce055536",
  null
  
)

export default component.exports